var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehouseUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "inventory",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 230",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 255,67.2 128.3,7.6 1.7,67.4 9.6,83.9 25.7,76.2 v 144 H 43.9 V 75.6 h 169 v 144.8 h 18.2 v -144 l 16.1,7.5 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 135.46246,213.1087 v -12.57396 c 0,-17.36088 -12.86903,-31.43492 -28.74348,-31.43492 -15.874575,0 -28.743503,14.07404 -28.743503,31.43492 v 12.57396 z m 0,0 h 45.98959 v -6.28699 c 0,-18.5183 -12.86903,-31.43491 -28.74349,-31.43491 -8.12463,0 -15.46228,3.93251 -20.69014,10.2547 m -8.05335,-54.26359 c 0,10.41659 -7.72136,18.86095 -17.24609,18.86095 -9.524736,0 -17.246105,-8.44436 -17.246105,-18.86095 0,-10.41659 7.721369,-18.86094 17.246105,-18.86094 9.52473,0 17.24609,8.44435 17.24609,18.86094 z m 40.24089,12.57398 c 0,6.94459 -5.14739,12.57396 -11.4974,12.57396 -6.35001,0 -11.4974,-5.62937 -11.4974,-12.57396 0,-6.94442 5.14739,-12.57398 11.4974,-12.57398 6.35001,0 11.4974,5.62956 11.4974,12.57398 z",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseUsers);
export default __webpack_public_path__ + "static/media/warehouse-users.cb94fde1a3ac2448090d66e662b6541b.svg";
export { ForwardRef as ReactComponent };